<script setup lang="ts">
/**
 * On Board — Form 45 (Consent to Act as Director, s.173C(a)) — 이사 1명당 1부(per-instance).
 *   원본 statutory (a)~(c) 비적격 선언문은 등록 템플릿에 그대로 있고, 화면은 운영자가
 *   입력하는 particulars + witness + [[Signers]] 만 문서형으로 재현한다.
 */
import CddVarField from '../cdd/CddVarField.vue';
import './onboardDoc.css';
</script>

<template>
  <div class="agm-doc">
    <div class="doc-head">
      <div class="doc-title">THE COMPANIES ACT 1967</div>
      <div class="doc-sub">SECTION 173C(a)</div>
      <div class="doc-sub">CONSENT TO ACT AS DIRECTOR AND STATEMENT OF NON-DISQUALIFICATION TO ACT AS DIRECTOR</div>
    </div>

    <table class="cdd-tbl">
      <tbody>
        <tr><td class="cdd-lcell">Name of Company</td><td><CddVarField field-key="company_name" label="Company Name" /></td></tr>
        <tr><td class="cdd-lcell">Company No.</td><td><CddVarField field-key="company_registration_no" label="Reg. No." /></td></tr>
      </tbody>
    </table>

    <p class="doc-p">
      I, the undermentioned person, hereby consent to act as a director of the abovenamed company with effect
      from <CddVarField field-key="effective_date" label="Effective Date" /> and declare
      that I am not disqualified from acting as a director and that I am aware of and undertake to abide by my
      duties, responsibilities and liabilities under the Act. <span class="doc-note">(Full statements (a)&ndash;(c)
      per s.173C(a) are reproduced in the generated document.)</span>
    </p>
    <div class="doc-p doc-note">Effective date is auto-linked from the DR - Change of Director appointment row.</div>

    <div class="sec-title">Particulars of Director</div>
    <table class="cdd-tbl">
      <tbody>
        <tr><td class="cdd-lcell">Name</td><td><CddVarField field-key="director_name" label="Director Name" /></td></tr>
        <tr><td class="cdd-lcell">Residential Address</td><td><CddVarField field-key="director_residential_address" label="Residential Address" /></td></tr>
        <tr><td class="cdd-lcell">Contact Address</td><td><CddVarField field-key="director_contact_address" label="Contact Address" /></td></tr>
        <tr><td class="cdd-lcell">*NRIC/FIN/Passport No.</td><td><CddVarField field-key="director_identification_no" label="Identification No." /></td></tr>
        <tr><td class="cdd-lcell">Nationality</td><td><CddVarField field-key="director_nationality" label="Nationality" /></td></tr>
        <tr><td class="cdd-lcell">Email address</td><td><CddVarField field-key="director_email" label="Email" /></td></tr>
        <tr><td class="cdd-lcell">Mobile No.</td><td><CddVarField field-key="director_mobile_no" label="Mobile No." /></td></tr>
      </tbody>
    </table>

    <table class="cdd-tbl">
      <tbody>
        <tr><td class="cdd-lcell">Dated this</td><td><CddVarField field-key="dated_on" label="Date" /></td></tr>
      </tbody>
    </table>
    <p class="doc-p" style="margin-top:14px">Signature (the appointed director signs their own consent):</p>
    <div class="sign-line"></div>
    <p class="doc-p"><CddVarField field-key="director_name" label="Director Name" /><br />Director</p>

    <div class="sec-title">Witness</div>
    <table class="cdd-tbl">
      <tbody>
        <tr><td class="cdd-lcell">Witness Name</td><td><CddVarField field-key="witness_name" label="Witness Name" /></td></tr>
        <tr><td class="cdd-lcell">*NRIC/FIN/Passport No.</td><td><CddVarField field-key="witness_identification_no" label="Witness ID" /></td></tr>
        <tr><td class="cdd-lcell">Occupation</td><td><CddVarField field-key="witness_occupation" label="Occupation" /></td></tr>
        <tr><td class="cdd-lcell">Date</td><td><CddVarField field-key="witness_date" label="Witness Date" /></td></tr>
      </tbody>
    </table>
  </div>
</template>
